import {
  useNotificationStore,
  NotificationType,
} from "@/store/useNotificationStore";

export function showImageFailureNotification(
  qualityCount: number,
  errorCount: number,
): void {
  if (qualityCount > 0 && errorCount === 0) {
    useNotificationStore
      .getState()
      .showNotification(
        qualityCount === 1
          ? "Your image wasn't clear enough to read."
          : `${qualityCount} of your images weren't clear enough to read.`,
        NotificationType.WARNING,
        4000,
      );
  } else if (errorCount > 0 && qualityCount === 0) {
    useNotificationStore
      .getState()
      .showNotification(
        errorCount === 1
          ? "Couldn't read your photo. Try again."
          : `Couldn't read ${errorCount} of your photos. Try again.`,
        NotificationType.WARNING,
        4000,
      );
  } else if (qualityCount > 0 && errorCount > 0) {
    const n = qualityCount + errorCount;
    useNotificationStore
      .getState()
      .showNotification(
        `Couldn't read ${n} of your photos. Try again.`,
        NotificationType.WARNING,
        4000,
      );
  }
}
